import React from 'react';

import {complete} from 'account-portal-library/lib/appleSignIn';
import {parseCookies, validateSessionToken, isValidGoToURL} from 'account-portal-library/lib/helperFunctions'

import Loader from '../Loader';
import AppVars from '../../AppVars.js';
import Logger from '../../Logger.js';
import { getGotoUrlFromCookies } from '../../gotoUrl';
import navigateWithAnalytics from '../../analytics/navigateWithAnalytics.js';


const appVars = AppVars.getInstance();
const logger = Logger.getInstance();

const VALID_FAILURE_URL = ["/noemail"]
const UNKNOWN_ERROR_URL = "/unknownerror";

class ContinueApple extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            complete: false,
            payload: null,
        }
    }

    //Finishes Google sign in flow
    async continueApple(){
        logger.log("stage", "Continuing Apple Sign In");
        const response = await complete(appVars.getBaseUrl(), appVars.getRealm(), appVars.getAppleSignInTree(), appVars.getDomain(), appVars.getName());
        logger.log("test", "Continue Apple Response");
        logger.log("test", response);
        if (response.status > 299){
            this.handleFailure(response);
        } else {
            this.handleSuccess(response);
        }
        
    }

    async checkToken(loginResponse){
        try {
            const tokenId = loginResponse.response.tokenId
            if (tokenId != null){
                logger.log("test", tokenId)
                const validateResponse = await validateSessionToken(tokenId, appVars.getBaseUrl(), appVars.getName(), appVars.getRealm());
                logger.log("test", validateResponse)
                return validateResponse.response.valid;
            } else{
                return false
            }
        }
        catch{
            return false
        }
        
    }

    async handleSuccess(loginResponse){
        if (loginResponse.response.tokenId != null && loginResponse.response.tokenId != undefined){
            const tokenValid = await this.checkToken(loginResponse)
            if (tokenValid){
                const gotoUrl = getGotoUrlFromCookies(['T', 'S']);
                navigateWithAnalytics(gotoUrl, "cookie-redirect", "auto");
            } else {
                navigateWithAnalytics(UNKNOWN_ERROR_URL, "error-redirect", "auto");
            }
        } else{
            this.props.savePayload(loginResponse)
        }
        
    }

    handleFailure(loginResponse){
    const failureUrl = loginResponse.failureUrl
    if (VALID_FAILURE_URL.includes(failureUrl)){
        navigateWithAnalytics(failureUrl, "error-redirect", "auto");
    }else {
        //this.setState({loading: false})
        navigateWithAnalytics(UNKNOWN_ERROR_URL, "error-redirect", "auto");
        }
    }


    render(){
        this.continueApple();
        return(
            <Loader />
        )
    }
}
    


export default ContinueApple;